import React, { useEffect, useState } from 'react';
import Chart from 'react-apexcharts';
import Skeleton from 'react-loading-skeleton';
import coverageVerificationAnalyticService from '../../../services/coverage-verification-analytics.service';

const TopVerifiedDrugs = ({ filters }) => {
  const [topVerifiedDrugs, setTopVerifiedDrugs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const getTopVerifiedDrugs = async () => {
      setError(false);
      setLoading(true);
      try {
        const data =
          await coverageVerificationAnalyticService.getTopVerifiedDrugs({
            ...filters,
          });
        setTopVerifiedDrugs(data?.top_verified_drugs || []);
      } catch (err) {
        console.error('Error fetching top verified drugs:', err);
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    getTopVerifiedDrugs();
  }, [filters]);

  if (loading) {
    return (
      <div className="mb-3">
        <Skeleton
          height={20}
          width={220}
          baseColor="#dee2e6"
          highlightColor="#e9ecef"
        />
        <Skeleton
          height={14}
          width={160}
          baseColor="#dee2e6"
          highlightColor="#e9ecef"
          style={{ marginTop: 8 }}
        />
        <Skeleton height={280} baseColor="#dee2e6" highlightColor="#e9ecef" />
      </div>
    );
  }

  if (error) {
    return (
      <div className="text-danger text-center fw-semibold">
        Failed to load top verified drug details.
      </div>
    );
  }

  if (topVerifiedDrugs.length === 0) {
    return (
      <div className="text-muted text-center fw-semibold">
        No drug verification data available.
      </div>
    );
  }

  const chartOptions = {
    chart: {
      type: 'bar',
      toolbar: { show: false },
    },
    plotOptions: {
      bar: {
        horizontal: true,
        borderRadius: 4,
      },
    },
    dataLabels: { enabled: false },
    tooltip: {
      y: { formatter: (val) => `${val} verifications` },
      followCursor: true,
    },
    colors: ['#10B981'],
    xaxis: {
      categories: topVerifiedDrugs.map((drug) => drug.drug_name),
      labels: { style: { colors: '#6b7280', fontSize: '12px' } },
      forceNiceScale: true,
    },
    yaxis: {
      labels: { style: { colors: '#6b7280' } },
    },
    grid: {
      borderColor: '#e5e7eb',
      strokeDashArray: 4,
    },
  };

  const series = [
    {
      name: 'Verifications',
      data: topVerifiedDrugs.map((drug) => drug.count),
    },
  ];

  return (
    <Chart options={chartOptions} series={series} type="bar" height={300} />
  );
};

export default TopVerifiedDrugs;
